import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authSrv: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  canActivate() {
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    return this.authSrv.school.pipe(
      take(1),
      map((school) => {
        const isAuth = !!school;
        if (isAuth) {
          return true;
        }
        return this.router.createUrlTree(['/login']);
      }),
    );
  }
}
